export async function dataUrlToFile(
  dataUrl: string,
  fileName: string,
  fileType: string
): Promise<File> {
  const response: Response = await fetch(dataUrl);
  const blob: Blob = await response.blob();
  return new File([blob], fileName, { type: fileType });
}

export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });

export const bytesToText = (bytes: number, decimals = 2): string => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let fileBytes = bytes;
  let i = 0;

  // eslint-disable-next-line no-plusplus
  for (i; fileBytes > 1024; i++) {
    fileBytes /= 1024;
  }

  return `${parseFloat(fileBytes.toFixed(decimals))} ${units[i]}`;
};

export const mapExtensionToPicture = (extension: string) => {
  const map = {
    pdf: 'picture_as_pdf',
    pptx: 'vrpano',
    png: 'collections',
    img: 'collections',
    jpg: 'collections',
    jpeg: 'collections',
    txt: 'description',
    html: 'html',
    css: 'css',
    js: 'javascript',
    json: 'code',
  };

  return map[extension] || 'attachment';
};
